import thinkingdata from 'thinkingdata-browser';

const appname1 = '9673995364';
const appname2 = 'cc4d70b281';
const appname3 = '4f4b9f6eff';
const appname4 = '1c';

const serverUrl1 = 'https://stat';
const serverUrl2 = '.jihuanshe';
const serverUrl3 = '.com';

const config = {
  appId: appname1 + appname2 + appname3 + appname4,
  serverUrl: serverUrl1 + serverUrl2 + serverUrl3,
  showLog: import.meta.env.PROD ? false : true
};

thinkingdata.init(config);

export const ta = thinkingdata; 